const ROW_META_KEYS = ['name', 'nameFilter', 'nameIcon', 'nameMarket']

const cellsOf = row => Object.entries(row || {})
	.filter(([key, value]) => !ROW_META_KEYS.includes(key) && value && typeof value === 'object')
	.map(([, value]) => value)

/**
 * A `trows` entry belongs to the main provider.
 *
 * The position service flags it on the row; the cell scan stays as a fallback so
 * a response without the flag still highlights the right row.
 */
export const isMainRow = row => row?.isMainRow ?? cellsOf(row).some(cell => cell.is_main_row)

/**
 * Rows ordered cheapest-first by average price, with the main row pinned on top
 * as the baseline the rest is read against.
 *
 * Presentation only: the backend keeps returning `trows` alphabetically, and the
 * Excel export builds its own rows from `ylist`, so neither is affected.
 * Rows with no price at all sink to the bottom.
 */
export const sortRowsByAveragePrice = (rows = []) => [...rows].sort((a, b) => {
	if (isMainRow(a)) return -1
	if (isMainRow(b)) return 1

	const priceA = a?.avgPrice
	const priceB = b?.avgPrice

	if (priceA == null) return priceB == null ? 0 : 1
	if (priceB == null) return -1

	return priceA - priceB
})
